import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getCalendar = actionFactory(types.GET_CALENDAR);
export const createHoliday = actionFactory(types.CREATE_HOLIDAY);
export const updateHoliday = actionFactory(types.UPDATE_HOLIDAY);
export const deleteHoliday = actionFactory(types.DELETE_HOLIDAY);
